export const PREFIX = 'Map/';
export const GOOGLE_MAP_API_KEY = 'AIzaSyCA5NQ0I3_r2KHwQnH4a7CDKX4XDawAL3k';

// Impact card actions
export const IMPACT_FILTER_REQUESTED = `${PREFIX}IMPACT_FILTER_REQUESTED`;
export const IMPACT_FILTER_ZOOM_CHANGED_REQUESTED = `${PREFIX}IMPACT_FILTER_ZOOM_CHANGED_REQUESTED`;
export const IMPACT_FILTER_SUCCEEDED = `${PREFIX}IMPACT_FILTER_SUCCEEDED`;
export const IMPACT_FILTER_FAILED = `${PREFIX}IMPACT_FILTER_FAILED`;

export const RESET_LITTERS = `${PREFIX}RESET_LITTERS`;
